/*
Format:

require.context(directory, useSubdirectories = false, regExp = /^\.\//)

*/
let req = require.context(
	'imports-loader?$=>window.jQuery!./src',
	true,
	/^(.*\.(js|sass|scss$))/im
);

req.keys().forEach( function( key ) {
	req( key );
} );




// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/webpack.index.js